import { render, staticRenderFns } from "./SideBarMenuItem.vue?vue&type=template&id=3aa644aa&scoped=true&"
import script from "./SideBarMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideBarMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SideBarMenuItem.vue?vue&type=style&index=0&id=3aa644aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa644aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
